function loadFonts() {
    let baileyFont = new FontFace(
        "Bailey",
        "url('https://cdn.shopify.com/s/files/1/0516/4282/6905/files/CaneletterSans.woff?v=1679587631') format('woff')"
    );
    baileyFont.load().then(function (font) {
        document.fonts.add(font);
    });

    let hippyChickFont = new FontFace(
        "Hippy Chick",
        "url('https://cdn.shopify.com/s/files/1/0516/4282/6905/files/KGOnlyHope.woff2?v=1709727794') format('woff2'), url('https://cdn.shopify.com/s/files/1/0516/4282/6905/files/KGOnlyHope.woff?v=1709727794') format('woff')"
    );
    hippyChickFont.load().then(function (font) {
        document.fonts.add(font);
    });

    let fairytaleFont = new FontFace(
        "Fairytale",
        "url('https://cdn.shopify.com/s/files/1/0516/4282/6905/files/Waltograph.woff2?v=1709731805') format('woff2'), url('https://cdn.shopify.com/s/files/1/0516/4282/6905/files/Waltograph.woff?v=1709731805') format('woff')"
    );
    fairytaleFont.load().then(function (font) {
        document.fonts.add(font);
    });
}

$(document).ready(function () {
    let jellybeanFont = new FontFace(
        "Jellybean",
        "url('https://cdn.shopify.com/s/files/1/0516/4282/6905/files/Jellybean.woff2?v=1709727175') format('woff2'), url('https://cdn.shopify.com/s/files/1/0516/4282/6905/files/Jellybean.woff?v=1709727175') format('woff')"
    );
    jellybeanFont.load().then(function (font) {
        document.fonts.add(font);
        createCanvas();
        createCanvasmob();
        document.querySelector(".preview__loading").remove();
    });

    function createCanvas() {
        // Load rest of fonts
        loadFonts();

        // var c = document.getElementById("product-preview--blanket");
        // var input = document.getElementById("preview-text");
        var c = document.querySelector(".product-preview--blanket");
        var input = document.querySelector(".preview-text");
        var ctx = c.getContext("2d");
        ctx.font = "50px 'Jellybean'";
        ctx.textBaseline = "middle";
        ctx.fillStyle = "#eee";

        $(".preview-text").keyup(function () {
            ctx.clearRect(0, 0, c.width, c.height);
            updateText();
        });

        function updateText(e) {
            var splitInput = input.value.split(/\r?\n/);
            textWidth = ctx.measureText(splitInput[0]).width;

            var secondLineText = splitInput[1];
            var secondLineTextWidth = ctx.measureText(secondLineText).width;

            if (splitInput[1]) {
                ctx.fillText(splitInput[0], c.width / 2 - textWidth / 2, 160);
                ctx.fillText(
                    secondLineText,
                    c.width / 2 - secondLineTextWidth / 2,
                    210
                );
            } else {
                ctx.fillText(splitInput[0], c.width / 2 - textWidth / 2, 210);
            }
        }

        $(".font-switch").click(function () {
            var newFont = this.getAttribute("data-font");
            ctx.font = "50px '" + newFont + "'";
            ctx.clearRect(0, 0, c.width, c.height);
            updateText();
        });

        $("#view-front").click(function (e) {
            e.preventDefault();
            $(this).addClass("active");
            $("#view-back").removeClass("active");

            $("#back-preview").css("display", "none");
            $("#product-preview").css("display", "none");
            $("#front-preview").css("display", "block");
        });

        $("#view-back").click(function (e) {
            e.preventDefault();
            $(this).addClass("active");
            $("#view-front").removeClass("active");

            $("#back-preview").css("display", "block");
            $("#product-preview").css("display", "block");
            $("#front-preview").css("display", "none");
        });

        // font face & colour switching
        $(".font-switch").click(function () {
            var newFont = this.getAttribute("data-font");
            ctx.font = "50px '" + newFont + "'";
            ctx.clearRect(0, 0, c.width, c.height);
            updateText();
            console.log(newFont);
            // $(this).closest('.product-customiser__options').find('.product-customiser__option').removeClass('active');
            // $(this).closest('.product-customiser__option').addClass('active');
        });

        $(".font-colour-switch").click(function () {
            var newColour = this.getAttribute("data-hex");
            ctx.fillStyle = newColour;
            ctx.clearRect(0, 0, c.width, c.height);
            updateText();
            // $(this).closest('.product-customiser__options').find('.product-customiser__option').removeClass('active');
            // $(this).closest('.product-customiser__option').addClass('active');
        });

        // image switching
        var backPreview = $(".back-preview");
        var frontPreview = $(".front-preview");

        $(".image-switch").click(function () {
            var newImage = $(this).attr("data-fabric");
            frontPreview.attr("src", newImage);
            console.log(newImage);
            // $(this).closest('.product-customiser__options').find('.product-customiser__option').removeClass('active');
            // $(this).closest('.product-customiser__option').addClass('active');
        });

        $(".image-switch--back").click(function () {
            var newImage = $(this).attr("data-fabric");
            backPreview.attr("src", newImage);
            console.log(newImage);
            // $(this).closest('.product-customiser__options').find('.product-customiser__option').removeClass('active');
            // $(this).closest('.product-customiser__option').addClass('active');
        });
    }
    function createCanvasmob() {
          // Load rest of fonts
          loadFonts();
  
          // var c = document.getElementById("product-preview--blanket");
          // var input = document.getElementById("preview-text");
          var cm = document.querySelector(".product-preview--blanket-mob");
          var input = document.querySelector(".preview-text");
          var ctxm = cm.getContext("2d");
          ctxm.font = "50px 'Jellybean'";
          ctxm.textBaseline = "middle";
          ctxm.fillStyle = "#eee";
  
          $(".preview-text").keyup(function () {
              ctxm.clearRect(0, 0, cm.width, cm.height);
              updateText();
          });
  
          function updateText(e) {
              var splitInput = input.value.split(/\r?\n/);
              textWidth = ctxm.measureText(splitInput[0]).width;
  
              var secondLineText = splitInput[1];
              var secondLineTextWidth = ctxm.measureText(secondLineText).width;
  
              if (splitInput[1]) {
                  ctxm.fillText(splitInput[0], cm.width / 2 - textWidth / 2, 160);
                  ctxm.fillText(
                      secondLineText,
                      cm.width / 2 - secondLineTextWidth / 2,
                      210
                  );
              } else {
                  ctxm.fillText(splitInput[0], cm.width / 2 - textWidth / 2, 210);
              }
          }
  
          $(".font-switch").click(function () {
              var newFont = this.getAttribute("data-font");
              ctxm.font = "50px '" + newFont + "'";
              ctxm.clearRect(0, 0, cm.width, cm.height);
              updateText();
          });
  
          $("#view-front").click(function (e) {
              e.preventDefault();
              $(this).addClass("active");
              $("#view-back").removeClass("active");
  
              $("#back-preview").css("display", "none");
              $("#product-preview").css("display", "none");
              $("#front-preview").css("display", "block");
          });
  
          $("#view-back").click(function (e) {
              e.preventDefault();
              $(this).addClass("active");
              $("#view-front").removeClass("active");
  
              $("#back-preview").css("display", "block");
              $("#product-preview").css("display", "block");
              $("#front-preview").css("display", "none");
          });
  
          // font face & colour switching
          $(".font-switch").click(function () {
              var newFont = this.getAttribute("data-font");
              ctxm.font = "50px '" + newFont + "'";
              ctxm.clearRect(0, 0, cm.width, cm.height);
              updateText();
              console.log(newFont);
              // $(this).closest('.product-customiser__options').find('.product-customiser__option').removeClass('active');
              // $(this).closest('.product-customiser__option').addClass('active');
          });
  
          $(".font-colour-switch").click(function () {
              var newColour = this.getAttribute("data-hex");
              ctxm.fillStyle = newColour;
              ctxm.clearRect(0, 0, cm.width, cm.height);
              updateText();
              // $(this).closest('.product-customiser__options').find('.product-customiser__option').removeClass('active');
              // $(this).closest('.product-customiser__option').addClass('active');
          });
  
          // image switching
          var backPreview = $(".back-preview");
          var frontPreview = $(".front-preview");
  
          $(".image-switch").click(function () {
              var newImage = $(this).attr("data-fabric");
              frontPreview.attr("src", newImage);
              console.log(newImage);
              // $(this).closest('.product-customiser__options').find('.product-customiser__option').removeClass('active');
              // $(this).closest('.product-customiser__option').addClass('active');
          });
  
          $(".image-switch--back").click(function () {
              var newImage = $(this).attr("data-fabric");
              backPreview.attr("src", newImage);
              console.log(newImage);
              // $(this).closest('.product-customiser__options').find('.product-customiser__option').removeClass('active');
              // $(this).closest('.product-customiser__option').addClass('active');
          });
      }
});
